import React from "react";
import { Grid } from "@mui/material";

import NotAvailable from "@/components/NotAvailable";
import NoDataFoundBase from "@/components/NoDataFound";

type CampaignListItem = {
  id?: string | number;
  [key: string]: any;
};

type CampaignListProps = {
  campaigns?: CampaignListItem[];
  isLoading?: boolean;
  searchValue?: string;
  emptyMessage?: string;
  renderCard: (_campaign: CampaignListItem) => React.ReactNode;
};

const NoDataFound = NoDataFoundBase as React.ComponentType<any>;

function CampaignList({
  campaigns = [],
  isLoading,
  searchValue = "",
  emptyMessage,
  renderCard,
}: CampaignListProps) {
  if (isLoading && !campaigns.length)
    return <NoDataFound className="my-5" message="Loading..." />;

  if (!campaigns.length) {
    return searchValue?.trim() ? (
      <NoDataFound
        className="my-5"
        message={`We couldn't find anything matching your search.\nTry again with a different term.`}
      />
    ) : (
      <NotAvailable className="my-5" message={emptyMessage} />
    );
  }

  return (
    <Grid container spacing={2} className="grid-view mt-2">
      {campaigns.map((campaign, index) => (
        <Grid size={{ xs: 12, md: 6, xl: 4 }} key={campaign?.id ?? index}>
          {renderCard(campaign)}
        </Grid>
      ))}
    </Grid>
  );
}

export default React.memo(CampaignList);
